import React from "react";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface SyaratKetentuanPageLayoutProps {
    children: React.ReactNode;
}

const SyaratKetentuanPageLayout = ({
    children,
}: SyaratKetentuanPageLayoutProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            padding={3}
            display="flex"
            justifyContent="center"
            sx={{ backgroundColor: "#45A779" }}
        >
            <Box
                sx={{
                    minHeight: "930px",
                    width: isTabletScreen ? "80%" : "50%",
                    backgroundColor: "#FFF",
                    borderRadius: 1,
                    paddingX: isTabletScreen ? 2 : undefined,
                    paddingY: 2,
                }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    paddingY={3}
                    paddingX={isTabletScreen ? 2 : 4}
                    sx={{
                        backgroundColor: "#fff",
                        borderRadius: "inherit",
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default SyaratKetentuanPageLayout;
